import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 6l-6 6l6 6","key":"svg-0"}]]

const IconChevronLeft = createReactComponent('outline', 'chevron-left', 'ChevronLeft', __iconNode);

export default IconChevronLeft;